import { useTranslation } from "react-i18next";
import BackGroundImage from "../../../assets/png/building_v2.png";


import styles from "./VMVInscriptionPlaceholder.module.scss";
function VMVInscriptionPlaceholder() {
  const { t } = useTranslation();
  return (
    <article className={styles.vmvPlaceholder}>
      <section
        className={styles.vmvPlaceholder__left}
        style={{ backgroundImage: `url(${BackGroundImage})` }}
      ></section>
      <section className={styles.vmvPlaceholder__right}>
        <h1>{t('components.vmvInscriptionPlaceholder.vmv')}</h1>
        <h2>{t('components.vmvInscriptionPlaceholder.title')}</h2>
        <p>
          {t('components.vmvInscriptionPlaceholder.desc1')}
          {/* {t('components.vmvInscriptionPlaceholder.desc2')} */}
        </p>

        <a type="button" href="#anchor-inscription" >{t("components.vmvInscriptionPlaceholder.btnInsc")}</a>
      </section>
    </article>
  );
}

export default VMVInscriptionPlaceholder;
